import type { TestCaseTItem, TestCaseTItemDir } from "../../core";

const sortAsc = (a: TestCaseTItem, b: TestCaseTItem) => (a.title.toLocaleLowerCase() > b.title.toLowerCase() ? 1 : -1);
const sortChildren = (children: TestCaseTItemDir["children"]): typeof children => {
  const dirs: TestCaseTItemDir["children"] = children.filter((it) => it.type === "folder");
  const leafs: TestCaseTItemDir["children"] = children.filter((it) => it.type === "payload");

  return dirs.sort(sortAsc).concat(leafs.sort(sortAsc));
};

export type TCasesSortArg = TestCaseTItem;
export type TCasesSortRtrn = TCasesSortArg;
export const tCasesSort = (arg: TCasesSortArg): TCasesSortRtrn => {
  if (arg.type === "payload") return arg;

  const sortedChildren = arg.children.map((child) => tCasesSort(child));
  return {
    ...arg,
    children: sortChildren(sortedChildren),
  };
};
